import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useShopQuery } from '../generated/graphql'

const Outer = styled.div`

`

const Inner = styled.div`
  display: flex;
  gap: 1rem;
  @media (max-width: 40rem){
    flex-direction: column;
    gap: 2rem;
  }
`

const Image = styled.div`
@media (max-width: 40rem){
  align-self: center;
}
img {
  display: block;
  height: 6.125rem;
  width: auto;
  border: 1px solid #D9D9D9;
  @media (max-width: 40rem){
    height: 6.25rem;
  }
}

`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const CategoryList = styled.div`
display: flex;

gap: 0.5rem;
`

const CategoryItem = styled.div`
  font-size: 0.875rem;
  letter-spacing: 0.02em;
  font-weight: 600;
  color: white;
  padding: 0.5625rem 2rem;
@media (max-width: 40rem){
  font-size: 0.8125rem;
line-height: 1.0030165452223558;
letter-spacing: 0.02em;
  padding: 0.375rem 1.75rem;
}
`

const Name = styled.div`

font-size: 1.5625rem;
line-height: 1.04;
letter-spacing: 0.02em;
color: var(--blue);
font-weight: 700;
margin-top: 0.8125rem;
@media (max-width: 40rem){
  font-size: 1.25rem;
line-height: 0.65;
letter-spacing: 0.02em;
margin-top: 0.8125rem;
}
`

const Area = styled.div`
font-size: 0.875rem;
line-height: 3;
letter-spacing: 0.02em;
margin-bottom: calc(-0.5lh - -0.5rem);
@media (max-width: 40rem){
  font-size: 0.8125rem;
line-height: 1.6153846153846154;
letter-spacing: 0.02em;
margin-top: 0.8125rem;
}
`

type ShopHeadSectionProps = {

}
export const ShopHeadSection: FunctionComponent<ShopHeadSectionProps> = () => {
  const shopQuery = useShopQuery({
    variables: {
      slug: location.pathname.match(/(?<=\/).*$/)?.[0] ?? ''
    }
  })
  const shop = shopQuery.data?.shop
  if(!shop) return null
  return <Outer>
    <Inner>
      <Image>
        <img src={shop.featuredImage?.node.mediaItemUrl ?? ''} />
      </Image>
      <TextContainer>
        <CategoryList>
          {shop.genres?.nodes.map(genre => {
            return <CategoryItem key={genre.slug} style={{backgroundColor: genre.genreFields?.color ?? ''}}>
              {genre.name}
            </CategoryItem>
          })}
        </CategoryList>
        <Name>
          {shop.title}
        </Name>
        <Area>
          {shop.shopFields?.area}
        </Area>
      </TextContainer>
    </Inner>
  </Outer>
}